import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingCallButton from "@/components/FloatingCallButton";
import Home from "@/pages/Home";
import Testimonials from "@/pages/Testimonials";
import Resources from "@/pages/Resources";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/resources" element={<Resources />} />
        </Routes>
        <Footer />
        <FloatingCallButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
